import { Observable, combineLatest } from 'rxjs';

import { GrayImage3, GrayImage2 } from './image';

import { map } from 'rxjs/operators';

import { Vector2 } from 'three';

export function applySlicer(
  image3: Observable<GrayImage3>,
  slicer: Observable<Slicer>,
) {
  return combineLatest(slicer, image3).pipe(
    map((x) => {
      const sli = x[0];
      const img = x[1];
      return sli.slice(img);
    }),
  );
}
export type SliceDirection = 'x' | 'y' | 'z';
export class Slicer {
  constructor(
    public readonly direction: SliceDirection = 'x',
    public readonly index:number = 0,
    public readonly min = 0,
    public readonly max = 1000,
  ) {
    this.min = Math.floor(this.min);
    this.max = Math.floor(this.max);
    this.index = Math.max(Math.min(Math.floor(this.index), this.max), this.min);
  }
  updateBoundmax(max: number) {
    return new Slicer(this.direction, this.index, this.min, max);
  }
  updateBoundmin(min: number) {
    return new Slicer(this.direction, this.index, min, this.max);
  }
  updateIndex(index: number) {
    if (index >= this.min && index < this.max) {
      return new Slicer(this.direction, index, this.min, this.max);
    } else {
      return this;
    }
  }
  addIndex(a: number) {
    return this.updateIndex(this.index + a);
  }
  updateDirection(direction: SliceDirection, image?: GrayImage3) {
    return new Slicer(
      direction,
      this.index,
      this.min,
      image === undefined ? this.max : imageShapeOfDirection(image, direction),
    );
  }
  shapeOfDirection(img: GrayImage3): number {
    return imageShapeOfDirection(img, this.direction);
  }

  slice(img: GrayImage3): GrayImage2 {
    const meta = img.meta;
    switch (this.direction) {
      case 'x':
        return new GrayImage2(
          new Vector2(meta.center.y, meta.center.z),
          new Vector2(meta.size.y, meta.size.z),
          new Vector2(meta.shape.y, meta.shape.z),
          loopSet(meta.shape.y, meta.shape.z, (y, z) =>
            img.pixel3(this.index, y, z),
          ),
        );
      case 'y':
        return new GrayImage2(
          new Vector2(meta.center.x, meta.center.z),
          new Vector2(meta.size.x, meta.size.z),
          new Vector2(meta.shape.x, meta.shape.z),
          loopSet(meta.shape.x, meta.shape.z, (x, z) =>
            img.pixel3(x, this.index, z),
          ),
        );

      case 'z':
        return new GrayImage2(
          new Vector2(meta.center.x, meta.center.y),
          new Vector2(meta.size.x, meta.size.y),
          new Vector2(meta.shape.x, meta.shape.y),
          loopSet(meta.shape.x, meta.shape.y, (x, y) =>
            img.pixel3(x, y, this.index),
          ),
        );
    }
  }
}

export function imageShapeOfDirection(
  img: GrayImage3,
  direction: SliceDirection,
) {
  switch (direction) {
    case 'x':
      return img.meta.shape.x;
    case 'y':
      return img.meta.shape.y;
    case 'z':
      return img.meta.shape.z;
  }
}
function loopSet(
  sizeX: number,
  sizeY: number,
  getter: (x: number, y: number) => number,
) {
  const result = new Float32Array(sizeX * sizeY);
  for (let x = 0; x < sizeX; x++) {
    for (let y = 0; y < sizeY; y++) {
      result[x * sizeY + y] = getter(x, y);
    }
  }
  return result;
}
